module.exports = __webpack_public_path__ + "img/faq1.11c9f6bf.svg";